<template>
	<div>
		<div class="flex justify-between">
			<div>
				<div class="inline-flex ml-4" v-if="lastPage !== 1">
					<span class="border-l border-t border-b border-b rounded-bl rounded-tl hover:bg-gray-200 cursor-pointer input-height" @click="previous">
						<font-awesome-icon :icon="['fa', 'chevron-left']" class="w-5 h-5 pr-1" size="lg" />
					</span>
					<span
						class="border-l border-t border-b font-bold input-height"
						@click="first"
						:class="{ 'bg-sp border-sp text-white': currentPage === 1, 'hover:bg-gray-200 cursor-pointer': currentPage !== 1 }"
						>1
					</span>
					<span class="border-l border-t border-b opacity-75 input-height" v-if="showDotsBefore && !showSecondToFirst">...</span>

					<span
						class="border-l border-t border-b font-bold w-10 input-height"
						:class="{ 'bg-sp border-sp text-white': currentPage === 2, 'hover:bg-gray-200 cursor-pointer': currentPage !== 2 }"
						@click="goTo(2)"
						v-if="showSecondToFirst"
					>
						2
					</span>

					<span
						class="border-l border-t border-b font-bold input-height"
						:key="page"
						v-for="page in pages"
						:class="{ 'bg-sp border-sp text-white': currentPage === page, 'hover:bg-gray-200 cursor-pointer': currentPage !== page }"
						@click="goTo(page)"
					>
						{{ page }}
					</span>

					<span
						class="border-l border-t border-b font-bold input-height"
						:class="{ 'bg-sp border-sp text-white': currentPage === lastPage - 1, 'hover:bg-gray-200 cursor-pointer': currentPage !== lastPage - 1 }"
						@click="goTo(lastPage - 1)"
						v-if="showSecondToLast"
					>
						{{ lastPage - 1 }}
					</span>

					<span class="border-l border-t border-b input-height opacity-75" v-if="showDotsAfter && !showSecondToLast">...</span>
					<span
						v-if="lastPage != 1"
						class="border-l border-t border-b font-bold input-height"
						@click="last"
						:class="{ 'bg-sp border-sp text-white': currentPage === lastPage, 'hover:bg-gray-200 cursor-pointer': currentPage !== lastPage }"
					>
						{{ lastPage }}
					</span>
					<span class="border hover:bg-gray-200 input-height cursor-pointer rounded-tr rounded-br" @click="next">
						<font-awesome-icon :icon="['fa', 'chevron-right']" class="w-5 h-5 pr-1" size="lg" />
					</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'BasePagination',
	props: {
		isBlocked: {},
		lastPage: {},
		total: {},
		value: { type: Number },
	},
	computed: {
		showSecondToLast() {
			return this.pages[this.pages.length - 1] + 2 === this.lastPage;
		},
		showSecondToFirst() {
			return this.pages[0] - 2 === 1;
		},
		showDotsAfter() {
			return this.currentPage + 2 <= this.lastPage && this.currentPage + 3 < this.lastPage && this.lastPage > 7;
		},
		showDotsBefore() {
			return this.currentPage - 2 > 0 && this.pages[0] - 1 !== 1;
		},
		pages() {
			const arr = [];

			if (this.lastPage > 7) {
				let index = 2;

				if (this.currentPage > 3) {
					index = this.currentPage - 2;
				}

				if (this.currentPage + 3 > this.lastPage) {
					index = this.lastPage - 5;
				}

				for (let i = 0; i < 5; i++) {
					arr.push(index);
					index++;
				}
			} else {
				for (let i = 2; i < this.lastPage; i++) {
					arr.push(i);
				}
			}

			return arr;
		},
		currentPage: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
	methods: {
		first() {
			if (this.isBlocked) {
				return;
			}
			this.currentPage = 1;
		},
		last() {
			if (this.isBlocked) {
				return;
			}
			this.currentPage = this.lastPage;
		},
		next() {
			if (this.isBlocked) {
				return;
			}
			if (this.currentPage + 1 <= this.lastPage) {
				this.currentPage++;
			}
		},
		previous() {
			if (this.isBlocked) {
				return;
			}
			if (this.currentPage - 1 > 0) {
				this.currentPage--;
			}
		},
		goTo(page) {
			if (this.isBlocked) {
				return;
			}
			this.currentPage = page;
		},
	},
};
</script>

<style>
.input-height {
	height: 43px;
	width: 43px;
	align-items: center;
	display: flex;
	justify-content: center;
	@apply .border-gray-400;
}
</style>
